import ReferencesList from '../Components/ReferencesList.svelte';
import SVGcomponent from '../Components/SVGComponent.svelte';
import {formatTimestamp} from '../Utilities/time_format';
import {sortHML} from '../Utilities/util';

export const tables = {
    "assessmentList": [
        {
            field: "name",
            label: "Assessment Name",
        },
        {
            field: "create_date",
            label: "Date Created",
            formatter: formatTimestamp
        },
        {
            field: "matter",
            label: "Matter Number"
        },
        {
            field: "assessment_type",
            label: "Assessment Type"
        }
    ],
    "assessmentTypeList": [
        {
            field: "name",
            label: "Assessment Type Name"
        },
        {
            field: "production",
            type: "checkbox",
            label: "Production Ready",
            sort_func: (a, b, desc) => {
                const l = !!a.production;
                const r = !!b.production;

                let order;
                if (l > r) {
                    order = desc ? 1 : -1;
                } else if (r > l) {
                    order = desc ? -1 : 1;
                } else {
                    order = 0
                }
                return order;
            },
            attrs: {
                width: "200px"
            }
        }
    ],
    "recommendations": [
        /*{
            field: "_id",
            label: "ID"
        },
        */
        {
            field: "function",
            label: "Function",
            attrs: {
                width: "120px"
            },
            rowAttrs: {
                class: 'function'
            },
            dataAttr: "function",
            hCenter: true,
            vCenter: true
        },
        {
            field: "category",
            label: "NIST Category",
            attrs: {
                width: "200px"
            },
            hCenter: true,
            vCenter: true
        },
        {
            field: "finding",
            label: "Finding",
            vCenter: true
        },
        {
            field: "probability",
            label: "Probability",
            attrs: {
                width: "135px"
            },
            rowAttrs: {
                class: 'risk'
            },
            dataAttr: "probability",
            hCenter: true,
            vCenter: true,
            sort_func: sortHML("probability")
        },
        {
            field: "impact",
            label: "Impact",
            attrs: {
                width: "120px"
            },
            rowAttrs: {
                class: 'risk'
            },
            dataAttr: "impact",
            hCenter: true,
            vCenter: true,
            sort_func: sortHML("impact")
        },
        {
            field: "overall",
            label: "Overall",
            attrs: {
                width: "120px"
            },
            rowAttrs: {
                class: 'risk'
            },
            dataAttr: "overall",
            hCenter: true,
            vCenter: true,
            sort_func: sortHML("overall")
        },
        {
            field: "recommendation",
            label: "Recommendation",
            rowAttrs: {
                class: 'recommendation'
            },
            vCenter: true
        },
        {
            field: "references",
            label: "References",
            attrs: {
                width: "175px"
            },
            component: ReferencesList,
            filterFunc: (filter, item) => {
                return item.references && item.references.find((ref) => {
                    return ref.control.toLowerCase().includes(filter.toLowerCase()) || ref.framework.toLowerCase().includes(filter.toLowerCase())
                })
                return true
            }
        }
    ],
    "positiveControls": [
        {
            field: "function",
            label: "Function",
            attrs: {
                width: "120px"
            },
            rowAttrs: {
                class: "function"
            },
            dataAttr: "function",
            hCenter: true,
            vCenter: true
        },
        {
            field: "title",
            label: "Title",
        },
        {
            field: "text",
            label: "Control Text"
        }
    ],
    "serviceRecommendations": [
        {
            field: "color",
            label: "Shield Color",
            attrs: {
                width: "120px"
            },
            rowAttrs: {
                class: "color"
            },
            dataAttr: "color",
            hCenter: true,
            vCenter: true
        },
        {
            field: "title",
            label: "Title",
        },
        {
            field: "description",
            label: "Service Description"
        }
    ],
    "keyRecommendations": [
        {
            field: "text",
            label: "Key Recommendation"
        }
    ],
    "assessmentPolicies": [
        {
            field: "name",
            label: "Policy Name"
        },
        {
            field: "recommendation",
            label: "Recommendation"
        },
        {
            field: "references",
            label: "References"
        }
    ],
    "threats": [
        {
            field: "name",
            label: "Threat Name"
        }
    ],
    "threatControls": [
        {
            field: "name",
            label: "Control"
        }
    ],
    "questions": [
        {
            field: "title",
            label: "title"
        },
    ],
    "libraries": [
        {
            field: "name",
            label: "Library Name"
        }
    ],
    "dashboards": [
        {
            field: "name",
            label: "Dashboard Name"
        }
    ],

    "SVG": [
        {
            field: "name",
            label: "Image Name"
        },
        {
            field: "svg",
            label: "Image",
            component: SVGcomponent,
            attrs: {
                width: "100px"
            },
        }
    ],

    "reportGraphic": [
        {
            field: "name",
            label: "Graphic Name"
        }
    ]

}